import React,{FC,useState,useEffect,useRef} from 'react';
import {useNavigate,useLocation,HashRouter,Routes,Route,useParams} from 'react-router-dom';
import logo from './logo.svg';
import { useThrottleFn } from 'ahooks'
import { Button, NavBar, TabBar,SearchBar,Toast,List,Popup,Form,Collapse } from 'antd-mobile'
import { SearchBarRef } from 'antd-mobile/es/components/search-bar'
import {
    AppOutline,
    MessageOutline,
    UnorderedListOutline,
    UserOutline,LeftOutline
} from 'antd-mobile-icons'
import './App.css';
import './demo2.css'
import axios from 'axios';
import Bottom from "./Bottom";
const Medicine: FC = (props) => {
    const [tabs,setTabs]=useState([] as any);
    const [art, setArt] = useState(null);
    const navigate=useNavigate();
    const mainElementRef = useRef<HTMLDivElement>(null);
    const searchRef = useRef<SearchBarRef>(null);
    const [form]=Form.useForm();
    useEffect(()=>{
        let items=[

        ];
        Toast.show({icon:'loading',content:'加载中...',maskClickable: false,duration:30000});
        // @ts-ignore
        axios({
            method:'post',url:'/data/medicine/api',data:{},reponseType:'json'
        }).then(function(response){
            Toast.clear();
            let json=response.data;
            if(json.success){
                let items=[];
                let idx=0;
                let activeKey='';
                json.data.items.map(item=>{
                    items.push({key:item.key,title:item.name,arts:item.arts});
                    if(idx==0){
                        activeKey=item.key;
                    }
                    idx++;
                });
                setTabs(items);
            }else{
                Toast.show({icon:'fail',content:json.message});
            }
        }).catch(function(error){
            console.log(error)
            Toast.show({icon:'fail',content:'系统错误，请稍候再试'});
        });
    },[]);
    const searchMedicine = (val:string) =>{
        Toast.show({icon:'loading',content:'搜索中...',maskClickable: false,duration:30000});
        // @ts-ignore
        axios({
            method:'post',url:'/data/medicine/api',data:{keywords:val},reponseType:'json'
        }).then(function(response){
            Toast.clear();
            let json=response.data;
            if(json.success){
                let items=[];
                let idx=0;
                let activeKey='';
                json.data.items.map(item=>{
                    items.push({key:item.key,title:item.name,arts:item.arts});
                    if(idx==0){
                        activeKey=item.key;
                    }
                    idx++;
                });
                setTabs(items);
                if(items.length==0){
                    Toast.show({icon:'fail',content:"未查询到相关信息，请更换搜索词后再次尝试查询"});
                }
            }else{
                Toast.show({icon:'fail',content:json.message});
            }
        }).catch(function(error){
            console.log(error)
            Toast.show({icon:'fail',content:'系统错误，请稍候再试'});
        });
    }
    return (<div className='app'>
        <Popup
            visible={art==null?false:true}
            onMaskClick={() => {
                setArt(null)
            }}
            position='right'
            bodyStyle={{ width: '100vw' }}
        >
        {art?<><div className='top'>
                <NavBar onBack={()=>{ setArt(null); }}>{art.title}</NavBar>
            </div>
            <div className='body page-prescription'>
                <div className='art-content'>
                    <div dangerouslySetInnerHTML={{__html:art.content}} />
                </div>
                <div className="footer-back-icon">
                    <LeftOutline style={{ fontSize: 28, color:'var(--adm-color-primary)' }} onClick={()=>{ setArt(null); }} />
                </div>
            </div></>:<></>}
        </Popup>
        <div className='top'>
            <NavBar back={null}>方症对应426条</NavBar>
        </div>
        <div className={'body page-prescription show-footer'}>
            <div>
                <Form  form={form} className="searchform" layout='horizontal'>
                    <Form.Item
                        name="searchText"
                        label={null}
                        extra={
                            <div>
                                <Button size='small' onClick={()=>{
                                    //let val = searchRef.current?.value;
                                    let val=form.getFieldValue("searchText");
                                    if(typeof(val)!="undefined"){
                                        searchMedicine(val);
                                    }
                                }}>搜索</Button>
                            </div>
                        }
                    >
                        <SearchBar placeholder='' clearable onSearch={(val)=>{ searchMedicine(val);  }} />
                    </Form.Item>
                </Form>
            </div>
            <div className="artlist" style={{width:'100%'}}>
                <Collapse defaultActiveKey={[]}>
                {tabs.map(item => (
                    <Collapse.Panel key={item.key} title={item.title}>
                        <List>
                            {item.arts&&item.arts.map(art => (
                                <List.Item key={art.key} className='art-title' onClick={()=>{ setArt(art); }}>{art.title}</List.Item>
                            ))}
                        </List>
                    </Collapse.Panel>
                ))}
                </Collapse>
                </div>
        </div>
        <div className='bottom'>
            <Bottom></Bottom>
        </div>
    </div>)
}

export default  Medicine;